import {
  FaChartLine, FaMoneyBillWave, FaSyncAlt, FaBan,
  FaUserFriends, FaClipboardCheck, FaGavel, FaHandshake,
  FaBox, FaFolder, FaCog, FaFileInvoice, FaExchangeAlt,
  FaTicketAlt, FaUserPlus
} from 'react-icons/fa';

export const TRANSACTION_TYPES = [
  {
    value: 'Emission',
    label: 'Émission',
    icon: FaChartLine,
    color: 'success',
    description: 'Création de nouveaux titres par l\'émetteur',
    requires: { 
      fromAccount: false, 
      toAccount: false, 
      conversion: false,
      documents: true 
    },
    categories: ['CGEM', 'CEPO', 'CENO'],
    guide: 'Utilisé pour créer de nouveaux titres. Requiert un prospectus d\'émission.',
    workflow: 'GLOBAL → TIRE (compte à répartir)'
  },
  {
    value: 'Souscription',
    label: 'Souscription',
    icon: FaUserPlus,
    color: 'primary',
    description: 'Souscription à des titres émis',
    requires: { 
      fromAccount: false, 
      toAccount: true, 
      conversion: false,
      documents: false 
    },
    categories: ['NOMP', 'PORT', 'NOCH','NOAD'],
    guide: 'Un investisseur souscrit à des titres nouvellement émis.',
    workflow: 'REPARTITION → TRANSIT → CLIENT'
  },
  {
    value: 'Negociation',
    label: 'Négociation',
    icon: FaMoneyBillWave,
    color: 'primary',
    description: 'Vente/achat entre investisseurs',
    requires: { 
      fromAccount: true, 
      toAccount: true, 
      conversion: false,
      documents: false 
    },
    categories: ['NOMP', 'PORT', 'NOCH','NOAD'],
    guide: 'Transfert de titres entre deux investisseurs avec contrepartie financière.',
    workflow: 'Source → TRANSIT → Destination'
  },
  {
    value: 'Conversion',
    label: 'Conversion',
    icon: FaSyncAlt,
    color: 'info',
    description: 'Changement de type de titre',
    requires: { 
      fromAccount: true, 
      toAccount: false, 
      conversion: true,
      documents: true 
    },
    categories: ['NOMP', 'PORT'],
    guide: 'Conversion d\'un type de titre vers un autre (ex: porteur → nominatif).',
    workflow: 'Source → TRANSIT → Nouveau titre'
  },
  {
    value: 'Annulation',
    label: 'Annulation',
    icon: FaBan,
    color: 'danger',
    description: 'Retrait définitif de titres',
    requires: { 
      fromAccount: true, 
      toAccount: false, 
      conversion: false,
      documents: true 
    },
    categories: ['NOMP', 'PORT'],
    guide: 'Destruction définitive de titres avec ajustement des comptes émetteurs.',
    workflow: 'Source → TRANSIT → Réduction CGEM/CENO/CEPO'
  },
  {
    value: 'Mutation',
    label: 'Mutation',
    icon: FaUserFriends,
    color: 'warning',
    description: 'Transmission sans contrepartie (héritage, donation)',
    requires: { 
      fromAccount: true, 
      toAccount: true, 
      conversion: false,
      documents: true 
    },
    categories: ['NOMP', 'NOCH', 'NPRO','NOAD'],
    guide: 'Transfert de titres sans contrepartie financière (succession, donation).',
    workflow: 'Source → TRANSIT → Destination'
  },
  {
    value: 'Antecedent',
    label: 'Antécédent',
    icon: FaClipboardCheck,
    color: 'secondary',
    description: 'Import initial de positions existantes',
    requires: { 
      fromAccount: false, 
      toAccount: true, 
      conversion: false,
      documents: false 
    },
    categories: ['NOMP', 'PORT'],
    guide: 'Import de positions existantes lors de l\'intégration d\'un nouveau client.',
    workflow: 'Création TIRE → TRANSIT → Destination'
  },
  {
    value: 'Sequestre',
    label: 'Séquestre',
    icon: FaGavel,
    color: 'dark',
    description: 'Mise sous contrôle judiciaire',
    requires: { 
      fromAccount: true, 
      toAccount: false, 
      conversion: false,
      documents: true 
    },
    categories: ['NOMP', 'TRNE'],
    guide: 'Gel de titres suite à décision judiciaire. Requiert une décision de justice.',
    workflow: 'Source → TRANSIT → Compte séquestre spécial'
  },
  {
    value: 'DetachementDividende',
    label: 'Détachement Dividende',
    icon: FaFileInvoice,
    color: 'success',
    description: 'Création de droits de dividende',
    requires: { 
      fromAccount: true, 
      toAccount: false, 
      conversion: false,
      documents: false 
    },
    categories: ['NOMP', 'PORT'],
    guide: 'Création de droits de dividende attachés aux titres détenus.',
    workflow: 'Création de droits dans le compte détenteur'
  },
  {
    value: 'ExerciceDroits',
    label: 'Exercice de Droits',
    icon: FaTicketAlt,
    color: 'info',
    description: 'Conversion de droits en titres',
    requires: { 
      fromAccount: true, 
      toAccount: false, 
      conversion: true,
      documents: true 
    },
    categories: ['NOMP', 'PORT'],
    guide: 'Exercice de droits (dividendes, souscription) pour obtenir de nouveaux titres.',
    workflow: 'Droits → TRANSIT → Nouveaux titres'
  },
  {
    value: 'CessionOnereuse',
    label: 'Cession Onéreuse',
    icon: FaHandshake,
    color: 'success',
    description: 'Vente avec contrepartie',
    requires: { 
      fromAccount: true, 
      toAccount: true, 
      conversion: false,
      documents: true 
    },
    categories: ['NOMP', 'PORT'],
    guide: 'Cession de titres avec contrepartie financière. Requiert un contrat de cession.',
    workflow: 'Source → TRANSIT → Destination'
  },
  {
    value: 'Livraison',
    label: 'Livraison',
    icon: FaBox,
    color: 'primary',
    description: 'Transfert physique des titres',
    requires: { 
      fromAccount: true, 
      toAccount: true, 
      conversion: false,
      documents: false 
    },
    categories: ['NOMP', 'PORT'],
    guide: 'Livraison physique de titres papier entre parties.',
    workflow: 'Source → TRNE → Destination'
  },
  {
    value: 'TransfertDossiers',
    label: 'Transfert Dossiers',
    icon: FaFolder,
    color: 'info',
    description: 'Transfert entre institutions',
    requires: { 
      fromAccount: true, 
      toAccount: true, 
      conversion: false,
      documents: true 
    },
    categories: ['NOMP', 'PORT'],
    guide: 'Transfert de portefeuille entre institutions financières.',
    workflow: 'Source → TRNE → Destination'
  },
  {
    value: 'TransfertTiers',
    label: 'Transfert à Tiers',
    icon: FaExchangeAlt,
    color: 'secondary',
    description: 'Transfert à un tiers',
    requires: { 
      fromAccount: true, 
      toAccount: true, 
      conversion: false,
      documents: false 
    },
    categories: ['NOMP', 'PORT'],
    guide: 'Transfert de titres à un tiers non client.',
    workflow: 'Source → TRNE → Destination'
  },
  {
    value: 'Administration',
    label: 'Administration',
    icon: FaCog,
    color: 'secondary',
    description: 'Opérations administratives',
    requires: { 
      fromAccount: true, 
      toAccount: false, 
      conversion: false,
      documents: false 
    },
    categories: ['NOMP', 'NPRO', 'NOAD', 'NADC'],
    guide: 'Opérations administratives diverses (ajustements, corrections).',
    workflow: 'Ajustement direct dans le compte'
  }
];

// Helper pour récupérer un type par sa valeur
export const getTransactionType = (value) => {
  return TRANSACTION_TYPES.find(type => type.value === value);
};

// Helper pour vérifier si un type nécessite des documents
export const requiresDocuments = (transactionType) => {
  const type = getTransactionType(transactionType);
  return type?.requires.documents || false;
};

// Helper pour obtenir la description détaillée
export const getTransactionGuide = (transactionType) => {
  const type = getTransactionType(transactionType);
  return type?.guide || 'Transaction standard sur titres non cotés.';
};